export default [
  {
    title: "FRCOphth Part 1",
    id: "frcophth1",
    price: 129,
    comingSoon: false,
    description: "Theoretical exam assessing ophthalmology and basic sciences",
    length: "6 months",
    css: "linear-gradient-3",
  },
  {
    title: "FRCOphth Part 2 (Written)",
    id: "frcophth2",
    price: 150,
    comingSoon: false,
    description: "Focuses on advanced ophthalmology knowledge",
    length: "6 months",
    css: "linear-gradient-3",
  },
  {
    title: "MSRA",
    id: "msra",
    price: 50,
    comingSoon: false,
    description: "Clinical knowledge & professional judgment for specialties",
    length: "6 months",
    css: "",
  },
  {
    title: "Interview Pack (ST1)",
    id: "interview_pack_st1",
    price: 100,
    comingSoon: false,
    description: "Interview pack with 30 Ophthalmology scenarios with actor briefs, candidate briefs, a mark scheme, and key points, to help perfect your Ophthalmology interviews.",
    length: "6 months",
    css: "linear-gradient-2",
  },
  {
    title: "FRCOphth Part 2 Refraction",
    id: "frcophth2-refraction",
    price: 0,
    comingSoon: true,
    description:
      "Tests refraction skills, a crucial competency for ophthalmologist",
    css: "",
  },
  {
    title: "FRCOphth Part 2 Oral Exam",
    id: "frcophth2-oral",
    price: 0,
    comingSoon: true,
    description: "Based on the OST learning outcomes",
    css: "linear-gradient-2",
  },
];
